/**************************************************************************************************/
/** @import Helpers/Components                                                                   **/
/**************************************************************************************************/
import { BaseElement } from '@/Helpers/Components/DataForm/BaseElement'

/**************************************************************************************************/
/** @export Class @name InputDatePicker                                                          **/
/**************************************************************************************************/
export class InputDatePicker extends BaseElement
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private readonly type = 'InputDatePicker'
	private value: string | null

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor(key: string, label: string)
	{
		super()
		this.Key   = key
		this.Label = label
		this.value = null
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public get Type() : string
	{
		return this.type
	}

	public get Value() : string | null
	{
		return this.value
	}

	public set Value(value)
	{
		this.value = value
	}

	public clearDate() : this
	{
		this.value = null
		return this
	}

	public setDate(date: string) : this
	{
		const dateOnly = date.split('T')[0]
		this.value = dateOnly
		return this
	}
}